export default "__VITE_ASSET__BwrwuIg5__"